import { useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormProvider, useFieldArray, useForm } from 'react-hook-form'

import schema from '../../../../../../../validators/clientSchema'
import { DialogModal } from '../../../../../../../components/DialogModal'
import { ClientContactForm } from './ClientContactForm'
import { AddNewContactForm } from './AddNewContactForm'
import { type ClientDomain } from '../../../../../../../types/domain/client-domain'

type Contact = {
  name: string
  email: string
  phone: string
}

export type ClientContactsFormValues = {
  name: string
  contacts: Contact[]
}

type ClientContactsFormsManagerProps = {
  defaultValues?: ClientDomain
  isSubmitting: boolean
  onClose: () => void
  onSubmit: (data: ClientContactsFormValues) => void
}

export const ClientContactsFormsManager = ({
  defaultValues,
  isSubmitting,
  onClose,
  onSubmit,
}: ClientContactsFormsManagerProps) => {
  const [isAddingNewContact, setIsAddingNewContact] = useState(false)

  const form = useForm<ClientContactsFormValues>({
    defaultValues,
    mode: 'all',
    resolver: yupResolver(schema),
  })

  const { fields, append, remove, update } = useFieldArray({
    name: 'contacts',
    control: form.control
  })

  const clientTitle = `${defaultValues ? 'Editar' : 'Cadastrar'} cliente`
  const title = isAddingNewContact ? 'Adicionar contato' : clientTitle

  const handleAddNewContact = ({ name, email, phone }: Contact) => {
    append({ name, email, phone })
    setIsAddingNewContact(false)
  }

  return (
    <DialogModal
      isOpen
      title={title}
      onClose={onClose}
      styleBox={{ maxWidth: 668, height: 'fit-content' }}
    >
      <div className="lg:px-10 px-4 pt-8 pb-6 max-h-[85vh] overflow-y-scroll">
        {isAddingNewContact ? (
          <AddNewContactForm
            onSubmit={handleAddNewContact}
            onCancel={() => setIsAddingNewContact(false)}
          />
        ) : (
          <FormProvider {...form}>
            <ClientContactForm
              contactFields={fields}
              defaultValues={defaultValues}
              onSubmit={onSubmit}
              onAddNewContact={() => setIsAddingNewContact(true)}
              onRemoveContact={remove}
              onUpdateContact={update}
              isSubmitting={isSubmitting}
            />
          </FormProvider>
        )}
      </div>
    </DialogModal>
  )
}
